// extracted by mini-css-extract-plugin
module.exports = {"loader-holder":"loader_loader-holder__3Wikg","load-spinner":"loader_load-spinner__mZSlq","rotate":"loader_rotate__2u7I1"};